import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/contacts`;

export const getMemberList = (paginationInfo) => callApi({
    method: 'POST',
    endpoint: `${basePath}/get-member-list`,
    body: paginationInfo
  });
